module.exports = __webpack_public_path__ + "img/one.f29c5bf5.png";